<template>
  <div class="view-right">
    <div class="view-list">
      <ViewItem
        v-for="(item, index) in list"
        :key="index"
        :index="index"
        :len="list.length"
        :isShowBom="isShowBom"
        :data="item"
        isSource
      />
    </div>

    <div class="view-operate">
      <el-button
        v-if="list[0].tableBomData.length"
        type="primary"
        size="mini"
        @click="toggleBom"
        plain
      >
        {{ isShowBom ? '全部收起↑' : '全部展开↓' }}
      </el-button>

      <el-button class="print-btn" type="primary" size="mini" @click="jumpPrint"> 打印 </el-button>
    </div>
  </div>
</template>

<script>
import ViewItem from './view-item'
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  components: {
    ViewItem
  },
  data() {
    return {
      isShowBom: true
    }
  },
  methods: {
    toggleBom() {
      this.isShowBom = !this.isShowBom
    },
    jumpPrint() {
      this.$emit('print')
    }
  }
}
</script>

<style lang="less" scoped>
.view-right {
  position: relative;
  flex: 1;
  .view-list {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: @colorWhite;
    border: @border;
    overflow-y: auto;
    .scroll-bar();
  }
  .view-operate {
    position: absolute;
    right: 1px;
    top: 1px;
    padding: 10px;
    background: @colorWhite;
    z-index: 9;
  }
}
</style>
